const { get } = require('@ebay/str-ui-utils/retriever');
const { getTrackingData } = require('./tracking-util');

module.exports = class {
    onButtonClick(tspan) {
        this.emit('click');

        const triggerTracking = get(window, 'triggerTracking');

        if (triggerTracking) {
            const trackingData = getTrackingData(this.input, tspan);

            if (trackingData) {
                triggerTracking('pulsar', trackingData);
            }
        }
    }
};
